export enum RegistrationDisplayFlags {
    NOT_USED = 0,
    USED_FOR_PUBLIC_REGISTRATION = 1,
    USED_FOR_ADMINISTRATIVE_REGISTRATION = 2,
    ALWAYS_USED = 3,
}
